import _objectDestructuringEmpty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["overlayWidth", "title", "overlayClassName", "overlayStyle", "className"],
  _excluded2 = ["icon", "iconProps", "labelProps", "title", "iconPlacement", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuText from "../DixuText/DixuText";
import React from 'react';
import { toRem } from "../../utils/Utils";
const DixuTooltip = _ref => {
  let {
      overlayWidth,
      title,
      overlayClassName,
      overlayStyle,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-tooltip', className);
  const overlayClasses = classNames('dixu-tooltip-overlay', overlayClassName);
  return /*#__PURE__*/React.createElement(Tooltip, _objectSpread({
    trigger: ['hover', 'click', 'focus'],
    title: (() => {
      if (!title) {
        return undefined;
      }
      return /*#__PURE__*/React.createElement(DixuText, {
        font: "2",
        color: "2-1",
        whiteSpace: "pre-line"
      }, title);
    })(),
    className: classes,
    overlayClassName: overlayClasses,
    overlayStyle: _objectSpread({
      maxWidth: toRem(overlayWidth)
    }, overlayStyle)
  }, rest));
};
const DixuLabelledTooltip = _ref2 => {
  let {
      icon,
      iconProps,
      labelProps,
      title,
      iconPlacement,
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-labelled-tooltip', {
    'dixu-labelled-tooltip--titled': title
  }, className);
  const iconCol = /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, _objectSpread(_objectSpread({
    font: '4'
  }, iconProps), {}, {
    className: classNames('dixu-labelled-tooltip__icon', iconProps?.className)
  }), icon));
  return /*#__PURE__*/React.createElement(DixuTooltip, _objectSpread({
    className: classes,
    title
  }, rest), /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 10,
    wrap: false,
    type: "inline"
  }, iconPlacement === 'start' && iconCol, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, _objectSpread({}, labelProps), children)), iconPlacement === 'end' && iconCol));
};
DixuLabelledTooltip.defaultProps = {
  icon: undefined,
  iconProps: undefined,
  labelProps: undefined,
  iconPlacement: 'start',
  overlayWidth: undefined
};
DixuTooltip.Labelled = DixuLabelledTooltip;
const DixuInfoTooltip = _ref3 => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/React.createElement(DixuLabelledTooltip, _objectSpread({
    icon: /*#__PURE__*/React.createElement(InfoCircleOutlined, null)
  }, rest));
};
DixuTooltip.Info = DixuInfoTooltip;
const DixuWarningTooltip = _ref4 => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/React.createElement(DixuLabelledTooltip, _objectSpread({
    icon: /*#__PURE__*/React.createElement(ExclamationCircleOutlined, null)
  }, rest));
};
DixuTooltip.Warning = DixuWarningTooltip;
export default DixuTooltip;